module.exports = __webpack_public_path__ + "d79dfb424f1fd68f7da0ab3c5ab5e4bb.svg";